import React, { useEffect } from 'react';
import { validateToken } from './Login';
import { validateTokenWithRefresh } from './utils/apiClient';

// AuthGuard component for protecting routes that require authentication
const AuthGuard = ({ children }) => {
  useEffect(() => {
    // Initial token validation on component mount
    const initialValidation = async () => {
      try {
        await validateTokenWithRefresh();
      } catch (error) {
        console.error('Initial token validation failed:', error);
      }
    };
    
    initialValidation();

    // Set up interval to periodically check token validity (every 3 minutes)
    // Reduced from 5 minutes to be more proactive
    const intervalId = setInterval(async () => {
      try {
        await validateTokenWithRefresh();
      } catch (error) {
        console.error('Periodic token validation failed:', error);
      }
    }, 3 * 60 * 1000);

    // Listen for 401 unauthorized responses
    const handle401Error = async (event) => {
      console.warn('401 Unauthorized response detected');
      try {
        await validateTokenWithRefresh();
      } catch (error) {
        console.error('Token validation after 401 failed:', error);
      }
    };

    // Listen for token refresh events
    const handleTokenRefresh = (event) => {
      console.log('Token refresh event detected in AuthGuard');
    };

    window.addEventListener('unauthorized-error', handle401Error);
    window.addEventListener('tokenRefreshed', handleTokenRefresh);

    // Clean up
    return () => {
      clearInterval(intervalId);
      window.removeEventListener('unauthorized-error', handle401Error);
      window.removeEventListener('tokenRefreshed', handleTokenRefresh);
    };
  }, []);

  return <>{children}</>;
};

export default AuthGuard; 